import React from "react";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  pageSize,
  totalEntries,
  onItemsPerPageChange,
}) => {
	const handlePrevPage = () => {
		if (currentPage > 1) {
			onPageChange(currentPage - 1);
		}
	};

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5; // Maximum number of page numbers to display
    totalPages = totalPages ? totalPages : 1;
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage <= Math.ceil(maxVisiblePages / 2)) {
        for (let i = 1; i <= maxVisiblePages; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        pageNumbers.push(totalPages);
      } else if (currentPage >= totalPages - Math.floor(maxVisiblePages / 2)) {
        pageNumbers.push(1);
        pageNumbers.push("...");
        for (let i = totalPages - maxVisiblePages + 1; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        pageNumbers.push(1);
        pageNumbers.push("...");
        for (
          let i = currentPage - Math.floor(maxVisiblePages / 2);
          i <= currentPage + Math.floor(maxVisiblePages / 2);
          i++
        ) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        pageNumbers.push(totalPages);
      }
    }

    return pageNumbers;
  };

  const startEntry = (currentPage - 1) * pageSize + 1;
  const endEntry = Math.min(currentPage * pageSize, totalEntries);

  return (
    <div className="flex flex-wrap items-center justify-between mt-4 text-black gap-4">
      <div className="flex gap-8 text-sm items-center">
        Showing {startEntry} to {endEntry} of {totalEntries} entries
        <div>
          Show{" "}
          <select
            value={pageSize}
            className="border rounded-xl p-1.5"
            onChange={(e) => onItemsPerPageChange(parseInt(e.target.value))}
          >
            {[10, 25, 50, 100].map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>{" "}
          entries
        </div>
      </div>
      <div className="flex items-center">
        <button
          className="px-4 py-2 text-sm cursor-pointer border rounded-tl-md rounded-bl-md bg-transparent"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <ul className="flex">
          {getPageNumbers().map((pageNumber, index) => (
            <React.Fragment key={index}>
              {pageNumber === "..." ? (
                <li className="m">{pageNumber}</li>
              ) : (
                <li>
                  <button
                    className={`px-4 py-2 text-sm border cursor-pointer ${
                      currentPage === pageNumber
                        ? "bg-primary border-primary text-white"
                        : "bg-transparent text-thirdCol"
                    } `}
                    onClick={() => onPageChange(pageNumber)}
                    disabled={currentPage === pageNumber}
                  >
                    {pageNumber}
                  </button>
                </li>
              )}
            </React.Fragment>
          ))}
        </ul>
        <button
          className="px-4 py-2 text-sm border cursor-pointer rounded-tr-md rounded-br-md bg-transparent"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
